module.exports = {"id":"200677","name":"Pedro Mendes","rating":"75","photo":"./data/images/photos/1/200677.png","club":{"name":"Montpellier HSC","logo":"./data/images/clubs/MontpellierHSC.png"},"positions":["DC","DD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PedroMendes0.json
// module id = 3419
// module chunks = 0